import gql from "graphql-tag";

export const MY_CAFETERIA_DELETE_ASSET = gql`
  mutation deleteAsset($_id: String!) {
    deleteAsset(_id: $_id)
  }
`;
